import React from "react";
// import * as React from "react";

export default class VenatusAd extends React.Component {
  constructor(props) {
    super(props);
    this.adRef = React.createRef();
  }

  componentDidMount() {
    console.log("mounting", this.adRef.current);
    window.__vm_add = window.__vm_add || [];
    window.__vm_add.push(this.adRef.current);
  }

  componentWillUnmount() {
    console.log("unmounting", this.adRef.current);

    if (
      this.adRef.current.dataset.id === "65cb1bd7f1070e4763f1b1d6" ||
      this.adRef.current.dataset.id === "65e1a2359105a208f7635fdd"
    ) {
      window.__vm_remove_category = ["richmedia_all"];

      console.log("Venatus : vm_remove_category ");
    }
    (window.__vm_remove = window.__vm_remove || []),
      window.__vm_remove.push(this.adRef.current);

    // if (this.adRef.current.dataset.id === "65cb1bd7f1070e4763f1b1d6") {
    //   window.__vm_remove_category = ["richmedia_all"];
    //   console.log("Venatus : vm_remove_category ");
    // } else {
    //   window.__vm_remove = window.__vm_remove || [];
    //   window.__vm_remove.push(this.adRef.current);
    //   console.log("unmounting", this.adRef.current);
    // }
  }

  render() {
    const { placementId } = this.props;
    if (!placementId) {
      return null;
    }
    return (
      <div>
        <div
          className="vm-placement"
          data-id={placementId}
          data-publisher-ref="side-bar-ad"
          ref={this.adRef}
        ></div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ads/VenatusAd.js